document.addEventListener('DOMContentLoaded', () => {
        
  // Select all h2 elements in article
  const h2Elements = document.querySelectorAll('#article-top h2, #article-middle h2, #article-bottom h2');
  
  // Extract the text content of these h2 elements
  const h2Texts = Array.from(h2Elements).map(h2 => h2.textContent.trim()); // Trims any extra whitespace

  console.log(h2Texts); // Logs the array of text content
  
  // Find the target container where the texts will be displayed
  const targetContainer = document.getElementById('article-toc-2'); // Replace with your container's IDa
  h2Texts.forEach((text, index) => {
      const newElement = document.createElement('p'); // Create a new <p> element for each text
      newElement.classList.add('toc-item');
      newElement.textContent = text; // Set the text content
      
      // Add a click event to scroll to the corresponding h2 element
      newElement.addEventListener('click', () => {
          h2Elements[index].scrollIntoView({
              behavior: 'smooth', // Smooth scrolling animation
              block: 'center' // Scroll to the top of the element
          });
      });

      // Append the new element to the target container
      targetContainer.appendChild(newElement);
  });

});

document.addEventListener('DOMContentLoaded', () => {
const h2Elements = document.querySelectorAll('#article-top h2, #article-middle h2, #article-bottom h2');
const tocElements = document.querySelectorAll(".toc-item")
// Create an IntersectionObserver
const observer = new IntersectionObserver((entries) => {
let closestElement = null;
let smallestOffset = Infinity;

entries.forEach((entry) => {
if (entry.isIntersecting) {
  // Calculate distance from the top of the viewport
  const offset = Math.abs(entry.boundingClientRect.top);
  if (offset < smallestOffset) {
    smallestOffset = offset;
    closestElement = entry.target;
  }
}
});

// Highlight or log the closest element
if (closestElement) {
// Optionally add a class to highlight the closest element
tocElements.forEach((tocItem) => {
  tocItem.classList.remove('selected-toc-item')
  if (closestElement.textContent.includes(tocItem.textContent)){
    tocItem.classList.add('selected-toc-item');
  }
});
}
}, {
root: null, // Use the viewport as the root
rootMargin: '0px',
threshold: 0.5 // Trigger when 10% of the element is visible
});

// Observe all h2 elements
h2Elements.forEach((h2) => observer.observe(h2));
});